import { useGetUnreadNotificationsCount } from '@repo/api/notification/useGetUnreadNotificationsCount';
import { NotificationType } from '@repo/types/enums/notificationType';
import { AlignCenter, Bell, User } from 'lucide-react';

import NotificationsSheetTrigger from '@/components/features/notifications/NotificationsSheetTrigger';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { Chip } from '@/components/ui/chip';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { useCredentials } from '@/store/auth-store';

export function NavHeaderMobile() {
  const { name, avatarURL } = useCredentials();

  const { data } = useGetUnreadNotificationsCount(NotificationType.All);

  return (
    <header className={'border-border-primary bg-background sticky top-0 z-40 flex justify-between border-b p-3 md:hidden'}>
      <SidebarTrigger>
        <AlignCenter />
      </SidebarTrigger>
      <div className={'flex gap-2'}>
        <Chip isInvisible={!data} variantColor={'brand'} variant={'solid'} placement={'top-right'} isDot={true}>
          <NotificationsSheetTrigger asChild>
            <Button size={'md'} variant={'ghost'}>
              <Bell />
              <span className="sr-only">powiadomienia</span>
            </Button>
          </NotificationsSheetTrigger>
        </Chip>

        <Avatar size={'md'}>
          <AvatarImage src={avatarURL ?? undefined} alt={name} />
          <AvatarFallback>
            <User />
          </AvatarFallback>
        </Avatar>
      </div>
    </header>
  );
}
